module.exports = __webpack_public_path__ + "img/2.f4a99c42.png";